import React, { useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import InputControl from '../../components/InputControl'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useMutation, useQuery,useQueryClient } from '@tanstack/react-query'
import requestApi from '../../utils/request'
import Swal from 'sweetalert2'

//#region Validation Schema For Fees
const FeesValidationSchema = yup.object({
    buyerServiceFees: yup
        .string()
        .required('Buyer Service Fees is a required')
        .matches(
            /^[+]?\d+(\.\d+)?$/,
            'Buyer Service Fees must be a positive value'
        )
        .matches(
            /^(0{0,3}|00{0,2}|0[0-9]{0,2}|100|0{0,2}[1-9]|[1-9][0-9]?)$/,
            "Buyer Service Fees can't be more than 100%"
        ),
        deliveryCharges: yup
        .string()
        .required('Delivery Charges is a required')
        .matches(
            /^[+]?\d+(\.\d+)?$/,
            'Delivery Charges must be a positive value'
        ),
        globalServiceFees: yup
        .string()
        .required('Global Service Fees is a required')
        .matches(
            /^[+]?\d+(\.\d+)?$/,
            'Global Service Fees must be a positive value'
        )
        .matches(
            /^(0{0,3}|00{0,2}|0[0-9]{0,2}|100|0{0,2}[1-9]|[1-9][0-9]?)$/,
            "Global Service Fees can't be more than 100%"
        )
})
//#endregion


//#region View Configuration Data API
async function viewConfigurationData() {
    return await requestApi.post(`/configuration/view`, {}, { headers: true }).then((res) => res.data)
}
//#endregion
const ConfigurationManagment = () => {

    const queryClient = useQueryClient()

    const {
        control,
        register,
        reset,
        setValue,
        handleSubmit,
        formState: { errors, dirtyFields, isValid }
    } = useForm({ resolver: yupResolver(FeesValidationSchema) })

    const handleFeesForm = (data) => {
        // const { buyerServiceFees, deliveryCharges, globalServiceFees } = data
        mutation.mutate(data)
    }
    //#region  API Call for View Data of Current-User
    const onSuccess = (response) => {
        
        const { buyerServiceFees, deliveryCharges, globalServiceFees } = response.data
        reset({
          buyerServiceFees ,
           deliveryCharges,
           globalServiceFees
        })
       
    }
    const onError = (error) => {
        console.log(error)
    }

    const { data,isLoading } = useQuery({
        queryKey: ['config-data'],
        onSuccess,
        onError,
        queryFn:viewConfigurationData
    })
    //#endregion

    function configurationUpdate(payload) {
        return requestApi.post(`/configuration/edit`, payload)
    }
    const mutation = useMutation(configurationUpdate, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
          
            queryClient.invalidateQueries('config-data')
        },
        onError: (err) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: err?.message
            })
        }
    })


    return (
        <div className="admin-card">
            <div class="head">
                <h2>Configuration Management</h2>
            </div>
            <div className="admin-form-body">
                <Form onSubmit={handleSubmit(handleFeesForm)}>
                    <Row>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <InputControl
                                    autoFocus={true}
                                    type="number"
                                    label="Buyer Service Fees (%)"
                                    name="buyerServiceFees"
                                    register={register}
                                    error={errors?.buyerServiceFees?.message}
                                />
                            </div>
                        </Col>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <InputControl
                                    type="number"
                                    label="Delivery Charges"
                                    name="deliveryCharges"
                                    register={register}
                                    error={errors?.deliveryCharges?.message}
                                />
                            </div>
                        </Col>
                        <Col xxl="4" lg="6" md="6">
                            <div className="form-group">
                                <InputControl
                                    type="number"
                                    label="Global Service Fees (%)"
                                    name="globalServiceFees"
                                    register={register}
                                    error={errors?.globalServiceFees?.message}
                                />
                            </div>
                        </Col>
                        <Col lg="12">
                            <button className="solid-red-btn">Save</button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    )
}

export default ConfigurationManagment
